export const sweep = "Kab";
export const undoCommandingBar = "Lab";
export const previousLabel = "Mab";
export const nextLabel = "Nab";
export const closeLabel = "Oab";
export const customizeToolbar = "Pab";
export default {sweep,undoCommandingBar,previousLabel,nextLabel,closeLabel,customizeToolbar};